import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@carm/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardHomePageComponent } from './pages/dashboard-home-page/dashboard-home-page.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { AccessRequestsWidgetComponent } from './components/access-requests/access-requests.component';
import { FinancialWidgetComponent } from './components/financial/financial.component';
import { MostRequestedWidgetComponent } from './components/most-requested/most-requested.component';
import { RecentTransactionsWidgetComponent } from './components/recent-transactions/recent-transactions.component';
import { RulingsWidgetComponent } from './components/rulings/rulings.component';
import { WhatsNewWidgetComponent } from './components/whats-new/whats-new.component';
import { CommercialAccountingComponent } from './components/commercial-accounting/commercial-accounting.component';
import { AppealsComponent } from './components/appeals/appeals.component';
import { PenaltiesComponent } from './components/penalties/penalties.component';


@NgModule({
  declarations: [
    DashboardHomePageComponent,
    RecentTransactionsWidgetComponent,
    MostRequestedWidgetComponent,
    RulingsWidgetComponent,
    FinancialWidgetComponent,
    AccessRequestsWidgetComponent,
    WhatsNewWidgetComponent,
    CommercialAccountingComponent,
    AppealsComponent,
    PenaltiesComponent,
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    TranslateModule,
    SharedModule,
  ],
  exports: [],
  providers: [ ],
})
export class DashboardModule { }
